import { Controller } from "@hotwired/stimulus"

// Sample Stimulus controller to verify setup is working
export default class extends Controller {
  static targets = ["output"]
  
  declare outputTarget: HTMLElement
  declare hasOutputTarget: boolean

  connect() {
    console.log("Hello controller connected")
  }

  greet() {
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = "Hello from Stimulus!"
    }
  }
}

